import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchUpdateCompany } from "./companyAPI";
import swal from 'sweetalert';
export interface UpdateCompanyState {
  updateCompany: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: UpdateCompanyState = {
    updateCompany: [],
  status: "idle",
};

export const GetUpdateCompany = createAsyncThunk(
  "UpdateCompany/fetchUpdateCompany",
  async (data:any) => {
    const response = await fetchUpdateCompany(data);
    return response;
  }
);

export const UpdateCompanySlice = createSlice({
  name: "UpdateCompany",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUpdateCompany.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetUpdateCompany.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetUpdateCompany.fulfilled, (state, action) => {
        state.status = "idle";
        state.updateCompany = action.payload;
        swal("Record updated success!",  "success");
      });
  },
});

export const {} = UpdateCompanySlice.actions;

export const selectUpdateCompany = (state: RootState) => {
  return state.UpdateCompany.updateCompany;
};

export default UpdateCompanySlice.reducer;
